import register0 from "../../../assets/images/auth/register0.png";
import register1 from "../../../assets/images/auth/register1.png";
import register2 from "../../../assets/images/auth/register2.png";

import classes from "./register-page.module.css";
import RegisterForm from "../components/register-form";
import { useEffect, useState } from "react";
import { redirect, useSearchParams, type ActionFunction } from "react-router-dom";
import { devbackendUrl } from "../../../utils/constants";
import { analyticsApi } from '../../../utils/analytics';
import { jwtDecode } from 'jwt-decode';
import { usePageTitle } from '../../../hooks/usePageTitle';
import { AUTH_REDIRECT_PARAM, getRedirectToFromRequest } from '../../../utils/auth-redirect';
import {
  createAuthActionError,
  getNetworkAuthError,
  getResponseErrorMessage,
} from "../utils/auth-action-errors";

const RegisterPage: React.FC<{}> = () => {
  usePageTitle('Register - Create Your Account');

  const [searchparams] = useSearchParams();
  const isRegistered = searchparams.get("registered") === "true";
  const [showCurrentForm, setShowCurrentForm] = useState(!isRegistered);
  useEffect(() => {
    if (isRegistered) {
      setShowCurrentForm(false);
    }
  }, [isRegistered]);
  return (
    <div className={classes.pageContainer}>
      {showCurrentForm ? (
        <img src={register0} alt="Colors" className={classes.Register0} loading="lazy" />
      ) : (<>
        <img src={register1} alt="Colors" className={classes.Register1} loading="lazy" />
        <img src={register2} alt="Colors" className={classes.Register2} loading="lazy" />
      </>)}
      <RegisterForm
        showCurrentForm={showCurrentForm}
        setShowCurrentForm={setShowCurrentForm}
      />
    </div>
  );
};

export default RegisterPage;

export const action: ActionFunction = async ({ request }) => {
  if (request.method !== 'POST') return null;

  const data = await request.formData();
  const authData = {
    email: data.get('email') as string | null,
    password: data.get('password') as string | null,
    username: data.get('username') as string | null,
    nickname: data.get('nickname') === '' ? data.get('username') as string | null : data.get('nickname') as string | null,
  };

  try {
    const response = await fetch(`${devbackendUrl}auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(authData)
    });

    if (response.status === 403 || response.status === 400) {
      const message = await getResponseErrorMessage(response, 'Unable to register with those details.');
      return createAuthActionError('Sign up failed', message);
    }

    if (!response.ok) {
      const message = await getResponseErrorMessage(response, 'We could not create your account right now. Please try again.');
      return createAuthActionError('Sign up unavailable', message);
    }

    const resData = await response.json();
    const token = resData.access_token;

    if (!token) {
      return createAuthActionError('Sign up unavailable', 'The server response was missing a session token. Please try again.');
    }

    localStorage.setItem('token', token);

    // Link analytics visitor to user after successful registration
    try {
      const decoded = jwtDecode<{ sub: number }>(token);
      if (decoded.sub) {
        analyticsApi.linkUser(decoded.sub);
      }
    } catch (err) {
      console.debug('[Analytics] Failed to link user on register:', err);
    }

    const redirectTo = getRedirectToFromRequest(request);
    const params = new URLSearchParams({
      registered: 'true',
      [AUTH_REDIRECT_PARAM]: redirectTo,
    });

    return redirect(`/register?${params.toString()}`);
  } catch (error) {
    console.error('[Auth] Register request failed:', error);
    return getNetworkAuthError('register');
  }
}
